export default __webpack_public_path__ + "static/media/greenVector.89b8b84c.svg";